<template>

    <div class="row m-1 mt-2" v-if="inheritanceFlow && inheritance">

        <a ref="attachmentA"></a>

        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-8">
                            <router-link class="btn-link d-block" :to="{name:'route-index'}">
                                <font-awesome-icon icon="arrow-circle-left"></font-awesome-icon> Elenco pratiche
                            </router-link>
                            <h1 class="mb-3">
                                Pratica  {{inheritance.internalCode}} del {{inheritance.date | formatDate }} <small v-if="inheritance.chargeUser" class="text-muted d-block font-italic">In carico a {{inheritance.chargeUser.firstName}} {{inheritance.chargeUser.lastName}}</small>
                            </h1>

                            <h5 class="mb-3" :class="inheritance.state | stateTextCss">
                                <font-awesome-icon icon="circle"></font-awesome-icon>

                                {{inheritance.state | state}}
                            </h5>
                            <div class="alert alert-danger" v-if="!inheritance.allPayed && isAdministrative">

                                <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
                                Attenzione, ci sono pagamenti pendenti.
                            </div>
                            <div class="row mb-3">
                                <div class="col-12">
                                    <button type="button" class="btn btn-xs  btn-orange  m-1" v-on:click="previous" v-if="isAdministrator && inheritance.state=='KO'">Torna allo step precedente <font-awesome-icon icon="arrow-circle-left"></font-awesome-icon></button>
                                    <button type="button" class="btn btn-xs  btn-orange  m-1" v-on:click="resetInheritance" v-if="actionEnable('reset')">Rielabora proforma  <font-awesome-icon icon="arrow-circle-left"></font-awesome-icon></button>

                                    <button type="button" class="btn btn-xs btn-orange m-1" v-on:click="inChargeToMe" v-if="actionEnable('chargeme')">Prendi in carico</button>
                                    <button type="button" class="btn btn-xs  btn-dark m-1" v-on:click="changeoperator" v-if="actionEnable('changeoperator')">Modifica operatore <font-awesome-icon icon="user"></font-awesome-icon></button>
                                    <button type="button" class="btn btn-xs  btn-primary m-1" v-on:click="toggleReadOnly" v-if="actionEnable('savebaseinformation') && isReadOnly">Modifica dati base inseriti  <font-awesome-icon icon="edit"></font-awesome-icon></button>
                                    <!--<button type="button" class="btn btn-xs  btn-primary m-1" v-on:click="saveBase" v-if="actionEnable('savebaseinformation') && !isReadOnly">Salva dati base  <font-awesome-icon :icon="['far','save']"></font-awesome-icon></button>-->
                                    <button type="button" class="btn btn-xs  btn-danger m-1" v-on:click="toggleReadOnly(true)" v-if="actionEnable('savebaseinformation') && !isReadOnly">Annulla  <font-awesome-icon :icon="['far','times-circle']"></font-awesome-icon></button>
                                    <button type="button" class="btn btn-xs  btn-orange m-1" v-on:click="nextState" v-if="actionEnable('nextState') && nextStateEnable">Passa a {{nextStateDescription() | state}}  <font-awesome-icon icon="arrow-circle-right"></font-awesome-icon></button>
                                    <button type="button" class="btn btn-xs  btn-indigo m-1" v-on:click="jumpOver" v-if="actionEnable('jumpOver') && nextStateEnable">Salta fase di acconto <font-awesome-icon icon="arrow-circle-right"></font-awesome-icon></button>
                                    <button type="button" class="btn btn-xs  btn-danger  m-1" v-on:click="ko" v-if="actionEnable('ko')">Sospendi pratica <font-awesome-icon icon="ban"></font-awesome-icon></button>
                                    <button type="button" class="btn btn-xs  btn-danger  m-1" v-on:click="stepOver" v-if="actionEnable('stepOver')">Forza passaggio a {{nextStateDescription() | state}}  <font-awesome-icon icon="arrow-circle-right"></font-awesome-icon></button>
                                    <button type="button" class="btn btn-xs  btn-warning  m-1" v-on:click="confirmInvalidData" v-if="actionEnable('confirmInvalidData')">Torna a modifica dati  <font-awesome-icon icon="arrow-circle-right"></font-awesome-icon></button>
                                </div>
                            </div>
                            <div class="card bg-danger" v-if="inheritance && inheritance.totalDownPaymentTaxes!=0 && inheritance.totalDownPaymentTaxes!=inheritance.totalBalanceTaxes">
                                <div class="card-body">
                                    <div class="row m-0 p-0">
                                        <div class="col-10">
                                            <h4>Totale imposte da file .DCM: </h4>
                                            <h4>Totale imposte da file .SUC:</h4>
                                            <h4>Differenza Imposte:</h4>

                                        </div>
                                        <div class="col-2">
                                            <h4 class="text-right">{{inheritance.totalDownPaymentTaxes | toCurrency}}</h4>
                                            <h4 class="text-right">{{inheritance.totalBalanceTaxes | toCurrency}}</h4>
                                            <h4 class="text-right">{{(inheritance.totalDownPaymentTaxes - inheritance.totalBalanceTaxes) | toCurrency}}</h4>

                                        </div>

                                    </div>
                                </div>
                            </div>
                            <form @submit.prevent="save">
                                <h3>Provenienza</h3>
                                <hr>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="name">Istituto</label>
                                            <p class="form-control-static">{{inheritance.authority.name}}</p>

                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="lastname">Agenzia</label>
                                            <p class="form-control-static">{{inheritance.agency.name}}</p>
                                        </div>
                                    </div>

                                </div>
                                <h3>Erede</h3>
                                <hr>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="name">Nome</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.name}}</p>
                                            <input type="text" class="form-control fullname" id="name" name="name" placeholder="Nome" v-model="inheritance.name" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="lastname">Cognome</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.surname}}</p>
                                            <input type="text" class="form-control fullname" id="surname" name="surname" placeholder="Cognome" v-model="inheritance.surname" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="username">Telefono</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.phone}}</p>
                                            <input type="text" class="form-control contact" id="phone" name="phone" placeholder="Telefono" v-model="inheritance.phone" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="email">Email</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.email}}</p>
                                            <input type="text" class="form-control contact" id="email" name="email" placeholder="Email" v-model="inheritance.email" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="fiscalCode">Codice fiscale</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.fiscalCode}}</p>
                                            <input type="text" class="form-control" id="fiscalCode" name="fiscalCode" placeholder="Codice Fiscale" v-model="inheritance.fiscalCode" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="birthDate">Data di nascita</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.birthDate | formatDate}}</p>
                                            <input type="date" class="form-control " id="birthDate" name="birthDate" placeholder="Data di nascita" v-model="inheritance.birthDate" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" for="birthCity">Comune di nascita</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.birthCity}}</p>
                                            <input type="text" class="form-control birthCity" id="birthCity" name="birthCity" placeholder="Comune di nascita" v-model="inheritance.birthCity" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">
                                            <label class="col-form-label" for="email">Provincia di nascita</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.birthDistrict}}</p>
                                            <input type="text" class="form-control birthDistrict" id="birthDistrict" name="birthDistrict" placeholder="Provincia di nascita" v-model="inheritance.birthDistrict" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">
                                            <label class="col-form-label" for="email">Nazione di nascita</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.birthCountry}}</p>
                                            <input type="text" class="form-control birthCountry" id="birthCountry" name="birthCountry" placeholder="Nazione di nascita" v-model="inheritance.birthCountry" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" for="birthCity">Comune di domicilio</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.city}}</p>
                                            <input type="text" class="form-control city" id="city" name="city" placeholder="Comune di nascita" v-model="inheritance.city" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">
                                            <label class="col-form-label" for="email">Provincia di domicilio</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.district}}</p>
                                            <input type="text" class="form-control district" id="district" name="district" placeholder="Provincia di domicilio" v-model="inheritance.district" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">
                                            <label class="col-form-label" for="email">Nazione di domicilio</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.country}}</p>
                                            <input type="text" class="form-control country" id="country" name="country" placeholder="Nazione di domicilio" v-model="inheritance.country" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" for="birthCity">Indirizzo di domicilio</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.address}}</p>
                                            <input type="text" class="form-control address" id="address" name="address" placeholder="Indirizzo di domicilio" v-model="inheritance.address" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" for="birthCity">CAP di domicilio</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.zipCode}}</p>
                                            <input type="text" class="form-control address" id="zipCode" name="zipCode" placeholder="CAP di domicilio" v-model="inheritance.zipCode" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                </div>
                                <h3>Defunto</h3>
                                <hr>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="name">Nome</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.deceaseName}}</p>
                                            <input type="text" class="form-control deceaseName" id="deceaseName" name="deceaseName" placeholder="Nome" v-model="inheritance.deceaseName" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="lastname">Cognome</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.deceaseSurname}}</p>
                                            <input type="text" class="form-control deceaseSurname" id="deceaseSurname" name="deceaseSurname" placeholder="Cognome" v-model="inheritance.deceaseSurname" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" for="name">Codice fiscale</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.deceaseFiscalCode}}</p>
                                            <input v-if="!isReadOnly" type="text" maxlength="16" class="form-control deceaseFiscalCode" id="deceaseFiscalCode" name="deceaseFiscalCode" placeholder="Codice fiscale" v-model="inheritance.deceaseFiscalCode">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" for="name">Data Decesso</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.deceaseDate | formatDate}}</p>
                                            <input type="date" class="form-control " id="deceaseDate" name="deceaseDate" placeholder="Data decesso" v-model="inheritance.deceaseDate" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" for="lastname">Comune di nascita</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.deceaseCity}}</p>
                                            <input type="text" class="form-control deceaseCity" id="deceaseCity" name="deceaseCity" placeholder="Comune di nascita" v-model="inheritance.deceaseCity" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">
                                            <label class="col-form-label" for="lastname">Provincia di nascita</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.deceaseDistrict}}</p>
                                            <input type="text" class="form-control deceaseDistrict" id="deceaseDistrict" name="deceaseCity" placeholder="Provinca di nascita" v-model="inheritance.deceaseDistrict" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">
                                            <label class="col-form-label" for="lastname">Nazione</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.deceaseCountry}}</p>
                                            <input type="text" class="form-control deceaseCountry" id="deceaseCountry" name="deceaseCountry" placeholder="Nazione" v-model="inheritance.deceaseCountry" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" for="name">Data di nascita</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.deceaseBirthdate | formatDate}}</p>
                                            <input type="date" class="form-control " id="deceaseBirthdate" name="deceaseBirthDate" placeholder="Data di nascita" v-model="inheritance.deceaseBirthdate" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                </div>


                                <h3 v-if="actionEnable('addPeople') || (inheritance.people && inheritance.people.length>0)">Intestatari <span class="badge badge-info rounded-circle text-white mr-4">{{inheritance.people?inheritance.people.length:0}}</span> <a v-if="actionEnable('addPeople')" v-on:click="addPerson" class="btn btn-sm btn-info">Aggiungi</a> </h3>
                                <hr v-if="actionEnable('addPeople') || (inheritance.people && inheritance.people.length>0)">
                                <div class="card" v-for="person in inheritance.people" v-if="!actionEnable('addPeople') ||(person.documents && person.documents.length>0)">
                                    <div class="card-header"><strong>Intestatario {{person.position}} -  {{person.name}} {{person.surname}}</strong></div>
                                    <div class="card-body">
                                        <div class="row m-0 p-0">
                                            <div class="col-12">
                                                <em class="font-weight-bolder d-block">Indirizzo</em>
                                                {{person.address}}
                                                {{person.zipCode}} - {{person.city}} ({{person.district}})
                                            </div>

                                        </div>
                                        <div class="row m-0 p-0">
                                            <div class="col-4">
                                                <em class="font-weight-bolder d-block">Codice fiscale</em>
                                                {{person.fiscalCode}}
                                            </div>
                                            <div class="col-4">
                                                <em class="font-weight-bolder d-block">Codice SDI</em>
                                                {{person.sdi}}
                                            </div>
                                            <div class="col-4">
                                                <em class="font-weight-bolder d-block">Indirizzo email</em>
                                                {{person.email}}
                                            </div>
                                            <div class="col-12" v-if="person.headingNote && person.headingNote!='' ">
                                                <em class="font-weight-bolder d-block">Note intestazione</em>
                                                {{person.headingNote}}
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="row border-bottom border-blue mb-2  bd-callout bd-callout-info" v-for="document in person.documents" v-if="(document.type =='proforma-downpayment' || document.type =='proforma-balance') && !document.canceled">

                                            <div class="col-6">
                                                <span class="badge badge-blue">
                                                    Pro-forma
                                                    <i v-if="document.type=='proforma-downpayment'"> acconto</i>
                                                    <i v-if="document.type=='proforma-balance'"> a saldo</i>
                                                </span>
                                                <h4>
                                                    <button title="modifica documento" class="btn btn-link btn-sm  text-danger" v-if="!document.payed && isAdministrator" @click.prevent="documentEdit(document.documentId,document.code)"><font-awesome-icon :icon="['far','edit']"></font-awesome-icon></button>Documento {{document.code}}
                                                    <button class="btn btn-sm btn-orange" v-if="!document.payed && isAdministrative && !inheritance.allPayed" @click.prevent="setPayed(document.documentId,document.code)">Segna come pagato</button>


                                                </h4>
                                                <!--<button class="btn btn-sm btn-indigo" v-if="!document.payed && isAdministrative && !inheritance.allPayed" @click.prevent="downloadDocument(document.documentId)">Anteprima</button>-->
                                            </div>

                                            <div class="col-6" v-if="getInvoice(document.type.replace('proforma-',''), person.documents)">
                                                <span class="badge badge-success">Fattura</span>
                                                <h4>Documento {{getInvoice(document.type.replace('proforma-',''),person.documents).code}}</h4>

                                            </div>
                                            <div class="col-12">

                                                <table class="table w-100 table-sm" v-if="actionEnable('add'+ document.type.replace('proforma-','')) ">
                                                    <thead>
                                                        <tr class="row">
                                                            <th scope="col" class="col-6">Descrizione</th>
                                                            <th scope="col" class="col-3">IVA</th>
                                                            <th scope="col" class="col text-right">Imponibile <i></i></th>
                                                            <th scope="col" class="col-1 text-right" v-if="actionEnable('add'+ document.type.replace('proforma-',''))"></th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr class="row" v-for="(row, index) in document.rows">
                                                            <td scope="row" class="col-6">
                                                                <div class="form-group">
                                                                    <span class="form-control-static" v-if="!actionEnable('add'+ document.type.replace('proforma-','')) || !row.editable">{{row.description}}</span>
                                                                    <input type="text" class="form-control " placeholder="Descrizione" v-model="row.description" v-if="actionEnable('add'+ document.type.replace('proforma-','')) && row.editable">
                                                                </div>
                                                            </td>
                                                            <td scope="row" class="col-3">
                                                                <select class="form-control" v-model="row.vatId" v-if="actionEnable('add'+ document.type.replace('proforma-',''))  && row.editable">
                                                                    <option v-for="v in vats" :value="v.vatId">{{v.description}}</option>
                                                                </select>
                                                                <span class="form-control-static" v-if="!actionEnable('add'+ document.type.replace('proforma-','')) || !row.editable">{{row.vat.description}}</span>


                                                            </td>
                                                            <td scope="row" class="col text-right">
                                                                <span class="form-control-static" v-if="!actionEnable('add'+ document.type.replace('proforma-','')) || ((!row.editable && inheritance.people.length==1))">{{row.amount | toCurrency}}</span>
                                                                <input type="number" step="0.01" min="0.01" class="form-control text-right" placeholder="imponibile" v-model.number="row.amount" v-if="actionEnable('add'+ document.type.replace('proforma-','')) && ((!row.editable && inheritance.people.length>1) || row.editable)">
                                                            </td>
                                                            <td scope="row" class="col-1 text-right" v-if="actionEnable('add'+ document.type.replace('proforma-',''))">

                                                                <a class="btn btn-sm" v-on:click="removeRow(document.documentId,row.documentRowId)" v-if="row.editable && document.rows.length>1"><font-awesome-icon icon="times" size="2x" class="text-danger" /></a>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="actionEnable('add'+ document.type.replace('proforma-',''))">
                                                            <td colspan="5" class="text-center">
                                                                <a v-on:click="newRow(document.documentId)"><font-awesome-icon icon="plus" class="text-info" /> Aggiungi nuova riga</a>


                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>


                                                <table class="table table-sm" style="width:95%; margin:auto;" v-if="!actionEnable('add'+ document.type.replace('proforma-','')) ">
                                                    <thead>
                                                        <tr class="row">
                                                            <th scope="col" class="col-6">Voci di Costo</th>
                                                            <th scope="col" class="col-3 text-right">Anticipazioni</th>
                                                            <th scope="col" class="col-3 text-right">Competenze</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr class="row" v-for="(row, index) in document.rows">
                                                            <td scope="row" class="col-6">

                                                                <span class="form-control-static" v-if="!actionEnable('add'+ document.type.replace('proforma-','')) || !row.editable">{{row.description}}</span>

                                                            </td>
                                                            <td scope="row" class="col-3 text-right">
                                                                <span class="form-control-static" v-if="!row.taxes">{{row.amount | toCurrency}}</span>


                                                            </td>
                                                            <td scope="row" class="col-3 text-right">
                                                                <span class="form-control-static" v-if="row.taxes">{{row.amount | toCurrency}}</span>

                                                            </td>

                                                        </tr>
                                                        <tr class="row border-top b-t-2 font-italic" v-if="document.totalHonorary>0">
                                                            <td> Rivalsa Cassa Previdenziale (4%)</td>
                                                            <td></td>
                                                            <td scope="row" class="col text-right">{{document.totalHonorary | toCurrency}}</td>
                                                        </tr>
                                                        <tr class="row border-top b-t-2 font-italic" v-if="document.totalHoldingTax>0">
                                                            <td> Ritenuta Acconto (20%)</td>
                                                            <td></td>
                                                            <td scope="row" class="col text-right">{{document.totalHoldingTax | toCurrency}}</td>
                                                        </tr>
                                                        <tr class="row border-top b-t-2 font-italic">
                                                            <td> Imposta sul valore aggiunto (22 %)</td>
                                                            <td></td>
                                                            <td scope="row" class="col text-right">{{document.totalVAT | toCurrency}}</td>
                                                        </tr>
                                                        <tr class="row">
                                                            <td><strong>Totale da pagare</strong></td>
                                                            <td></td>
                                                            <td scope="row" class="col text-right"><strong>{{document.totalAmount | toCurrency}}</strong></td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div class="row border-bottom border-blue mb-2  bd-callout bd-callout-info" v-for="document in person.documents" v-if="(document.type =='proforma-downpayment' || document.type =='proforma-balance') && document.canceled">

                                            <div class="col-6 text-muted">
                                                <span class="badge badge-blue">
                                                    Pro-forma
                                                    <i v-if="document.type=='proforma-downpayment'"> acconto</i>
                                                    <i v-if="document.type=='proforma-balance'"> a saldo</i>
                                                </span>
                                                <h4>Documento {{document.code}}  <span class="badge badge-danger">ANNULLATO</span>  </h4>

                                            </div>


                                            <div class="col-12  text-muted">

                                                <table class="table w-100 table-sm">
                                                    <thead>
                                                        <tr class="row">
                                                            <th scope="col" class="col-6">Descrizione</th>
                                                            <th scope="col" class="col-3">IVA</th>
                                                            <th scope="col" class="col text-right">Importo Netto</th>
                                                            <th scope="col" class="col-1 text-right" v-if="actionEnable('add'+ document.type.replace('proforma-',''))"></th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr class="row" v-for="(row, index) in document.rows">
                                                            <td scope="row" class="col-6">
                                                                <div class="form-group">
                                                                    <p class="form-control-static" v-if="!actionEnable('add'+ document.type.replace('proforma-','')) || !row.editable">{{row.description}}</p>
                                                                    <input type="text" class="form-control " placeholder="Descrizione" v-model="row.description" v-if="actionEnable('add'+ document.type.replace('proforma-','')) && row.editable">
                                                                </div>
                                                            </td>
                                                            <td scope="row" class="col-3">
                                                                <select class="form-control" v-model="row.vatId" v-if="actionEnable('add'+ document.type.replace('proforma-',''))  && row.editable">
                                                                    <option v-for="v in vats" :value="v.vatId">{{v.description}}</option>
                                                                </select>
                                                                <p class="form-control-static" v-if="!actionEnable('add'+ document.type.replace('proforma-','')) || !row.editable">{{row.vat.description}}</p>


                                                            </td>
                                                            <td scope="row" class="col text-right">
                                                                <p class="form-control-static" v-if="!actionEnable('add'+ document.type.replace('proforma-','')) || ((!row.editable && inheritance.people.length==1))">{{row.amount | toCurrency}}</p>
                                                                <input type="number" step="0.01" class="form-control text-right" placeholder="importo" v-model.number="row.amount" v-if="actionEnable('add'+ document.type.replace('proforma-','')) && ((!row.editable && inheritance.people.length>1) || row.editable)">
                                                            </td>
                                                            <td scope="row" class="col-1 text-right" v-if="actionEnable('add'+ document.type.replace('proforma-',''))">

                                                                <a class="btn btn-sm" v-on:click="removeRow(document.documentId,row.documentRowId)" v-if="row.editable && document.rows.length>1"><font-awesome-icon icon="times" size="2x" class="text-danger" /></a>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="actionEnable('add'+ document.type.replace('proforma-',''))">
                                                            <td colspan="5" class="text-center">
                                                                <a v-on:click="newRow(document.documentId)"><font-awesome-icon icon="plus" class="text-info" /> Aggiungi riga</a>


                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>



                                            </div>
                                        </div>
                                    </div>

                                </div>



                                <div class="row border-bottom mb-3" v-for="person in inheritance.people" v-if="actionEnable('addPeople') && (!person.documents || person.documents.length==0)">

                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-11">
                                                <h4>Intestatario {{person.position}}<button class="btn btn-sm btn-info" @click.prevent="addDocument(person.personId)" v-if="actionEnable('addBalance') && person.isNew==false">Aggiungi documento</button></h4>

                                            </div>
                                            <div v-if="actionEnable('addPeople') && person.position!=1" class="col-1 text-right"><a v-on:click="removePerson(person.personId)"> <font-awesome-icon icon="times" class="text-danger" /></a></div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" :for="'name-'+person.personId">Nome</label>
                                            <input type="text" :class="'form-control  person-fullname-'+person.personId" :id="'name-'+person.personId" :name="'name-'+person.personId" placeholder="Nome" v-model="person.name" v-if="actionEnable('addPeople')">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">

                                            <label class="col-form-label" :for="'surname-'+person.personId">Cognome</label>
                                            <input type="text" :class="'form-control  person-fullname-'+person.personId" :id="'surname-'+person.personId" :name="'surname-'+person.personId" placeholder="Cognome" v-model="person.surname" v-if="actionEnable('addPeople')">
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-group">

                                            <label class="col-form-label" :for="'address-'+person.personId">Indirizzo</label>
                                            <input type="text" :class="'form-control person-address-'+person.personId" :id="'address-'+person.personId" :name="'address-'+person.personId" placeholder="Indirizzo" v-model="person.address" v-if="actionEnable('addPeople')">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">

                                            <label class="col-form-label" :for="'zipcode-'+person.personId">CAP</label>
                                            <v-select :id="'zipcode-'+person.personId" v-model="person.capInfo" :reduce="c => c.cap || ''" v-on:search:focus="onFocus(person.position)" label="cap" :filterable="false" :options="options" @search="onSearch" @input="onSelect">
                                                <template slot="no-options">
                                                    Nessuna localit&agrave; o CAP trovato
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center" v-if="option!=null">
                                                        <strong>{{ option.cap }}</strong> - {{ option.comune }}
                                                    </div>
                                                </template>

                                            </v-select>
                                            <!--<input type="text" :class="'form-control person-zipcode-'+person.personId" :id="'zipcode-'+person.personId" :name="'zipCode-'+person.personId" placeholder="Cap" v-model="person.zipCode" v-if="actionEnable('addPeople')">-->
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <div class="form-group">

                                            <label class="col-form-label" :for="'city-'+person.personId">Città</label>
                                            <v-select :id="'city-'+person.personId" :name="'city-'+person.personId" v-model="person.capInfo" :reduce="c => c.comune" label="comune" :filterable="false" :options="options" @search="onSearch" @input="onSelect">
                                                <template slot="no-options">
                                                    Nessuna localit&agrave; o CAP trovato
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center" v-if="option!=null">
                                                        <strong>{{ option.cap }}</strong> - {{ option.comune }} ({{option.provincia}})
                                                    </div>
                                                </template>

                                            </v-select>
                                            <!--<input type="text" :class="'form-control person-city-'+person.personId" :id="'city-'+person.personId" :name="'city-'+person.personId" placeholder="Città" v-model="person.city" v-if="actionEnable('addPeople')">-->
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">

                                            <label class="col-form-label" :for="'district-'+person.personId">Provincia</label>

                                            <input type="text" :class="'form-control  person-district-'+person.personId" :id="'district-'+person.personId" :name="'district-'+person.personId" placeholder="provincia" v-model="person.capInfo.provincia" v-if="person.capInfo && actionEnable('addPeople')" readonly>
                                        </div>
                                    </div>


                                    <div class="col-6">
                                        <div class="form-group">

                                            <label class="col-form-label" :for="'fiscalcode-'+person.personId">Codice fiscale</label>
                                            <input type="text" :class="'form-control person-fiscalcode-'+person.personId" :id="'fiscalCode-'+person.personId" :name="'fiscalCode-'+person.personId" placeholder="Codice Fiscale" v-model="person.fiscalCode" v-if="actionEnable('addPeople')">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">

                                            <label class="col-form-label" :for="'sdi-'+person.personId">Codice SDI</label>
                                            <input type="text" maxlength="7" :class="'form-control person-sdi-'+person.personId" :id="'sdi-'+person.personId" :name="'sdi-'+person.personId" placeholder="SDI" v-model="person.sdi" v-if="actionEnable('addPeople')">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">

                                            <label class="col-form-label" :for="'email-'+person.personId">Indirizzo email</label>
                                            <input type="text" :class="['form-control',  'person-email' +person.personId]" :id="'email-'+person.personId" :name="'email-'+person.personId" placeholder="Indirizzo email" v-model="person.email" v-if="actionEnable('addPeople')">
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">

                                            <label class="col-form-label" :for="'email-'+person.personId">Note intestazione documento</label>
                                            <textarea :class="['form-control',  'person-note' +person.personId]" :id="'headingnote-'+person.personId" :name="'headingnote-'+person.personId" placeholder="Note intestazione" v-model="person.headingNote" v-if="actionEnable('addPeople')"></textarea>
                                        </div>
                                    </div>

                                    <div class="col-12">

                                    </div>

                                </div>



                                <div class="card bg-danger" v-if="inheritance && inheritance.totalDownPaymentTaxes!=0 && inheritance.totalDownPaymentTaxes==inheritance.totalBalanceTaxes">
                                    <div class="card-body">
                                        <div class="row m-0 p-0">
                                            <div class="col-12">
                                                <h4>Totale imposte da file .DCM: {{inheritance.totalDownPaymentTaxes | toCurrency}}</h4>

                                            </div>


                                        </div>
                                    </div>
                                </div>
                                <div class="card bg-info" v-if="inheritance && inheritance.totalBalanceTaxes>0">
                                    <div class="card-body">
                                        <div class="row m-0 p-0">
                                            <div class="col-7">
                                                <h4>Totale imposte da ripartire: {{inheritance.totalBalanceTaxes | toCurrency}}</h4>
                                                <h4>Totale imposte ripartite: {{inheritanceTaxes | toCurrency}}</h4>
                                                <h4>Totale imposte ancora da ripartite: {{(inheritance.totalBalanceTaxes -inheritanceTaxes) | toCurrency}}</h4>

                                            </div>
                                            <div class="col-5">
                                                <vue-easy-pie-chart v-if="inheritance && inheritance.totalBalanceTaxes>0" :percent="(inheritanceTaxes*100/inheritance.totalBalanceTaxes).toFixed(1)" track-color="#CCC" bar-color="#0d5480" scale-color="false"></vue-easy-pie-chart>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row">


                                </div>
                                <!--<h3>Filiale</h3>
                            <hr>-->

                                <div class="col-12" v-if="actionEnable('addCustomAttachment')">
                                    <h3>Elenco allegati necessari <small class="text-muted">(Almeno uno obbligatorio)</small></h3>
                                    <div class="row">
                                        <div class="col-3" v-for="attachment in attachmenttypes" v-if="attachment.operatorChoice">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" :name="'custom-'+attachment.attachmentTypeId" :value="attachment.attachmentTypeId" :id="'custom-'+attachment.attachmentTypeId" v-model="inheritance.customAttachments">
                                                <label class="custom-control-label" :for="'custom-'+attachment.attachmentTypeId">{{attachment.name}}</label>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div class="row  d-none">
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="name">Identificativo</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.externalCode}}</p>
                                            <input type="text" class="form-control" id="externalCode" name="externalCode" placeholder="Identificativo" v-model="inheritance.externalCode" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="lastname">Gestore</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.operator}}</p>
                                            <input type="text" class="form-control" id="operator" name="operator" placeholder="Gestore" v-model="inheritance.operator" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                </div>



                                <div class="row" v-for="r in inheritanceFlow.roles">

                                    <div class="col-12" v-if="r.attachments.length>0">
                                        <label class="col-form-label">Caricamento file</label>

                                        <select class="form-control" id="attachmentType" ref="attachmenTypeId">
                                            <option v-for="a in r.attachments" :value="a.type.attachmentTypeId">{{a.type.name}} {{a.capacity>0?"(Obbligatorio)":""}}</option>
                                        </select>
                                        <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions()" :useCustomSlot=true>
                                            <div class="dropzone-custom-content">
                                                <h3 class="dropzone-custom-title">Trascina il file qui</h3>
                                                <div class="subtitle">...o fai click per caricarlo dal tuo pc</div>
                                            </div>
                                        </vue-dropzone>
                                    </div>



                                    <div class="col-12" v-for="a in r.attachments">
                                        <div class="row">
                                            <div class="col" v-if="inheritance.attachments.filter(att=>att.attachmentTypeId == a.type.attachmentTypeId  && att.inheritanceId =='00000000-0000-0000-0000-000000000000').length>0">
                                                <label class="col-form-label" for="lastname">{{a.type.name}}</label>
                                                <div class="attachment row ml-2" v-for="file in inheritance.attachments.filter(att=>att.attachmentTypeId == a.type.attachmentTypeId  && att.inheritanceId =='00000000-0000-0000-0000-000000000000')">
                                                    <div class="col-1">
                                                        <font-awesome-icon :icon="getAttachmentIcon(file.originalFileName)" size="lg" class="text-primary" />
                                                    </div>
                                                    <div class="col-8">
                                                        {{file.originalFileName}} <i>({{getAttachmentSize(file.weight)}})</i>
                                                    </div>
                                                    <div class="col-3 text-right">
                                                        <button type="button" class="btn btn-link p-0" v-on:click="downloadAttachment(null,file.fileName,file.originalFileName)" title="Download"><font-awesome-icon icon="file-download" size="lg" class="text-info" /></button>
                                                        <button type="button" class="btn btn-link p-0" v-on:click="removeAttachment(file.attachmentId)" title="Elimina risorsa"><font-awesome-icon :icon="['far','trash-alt']" size="lg" class="text-danger" /><i class=" fa-lg text-danger far fa-trash-alt"></i></button>
                                                    </div>
                                                </div>


                                            </div>

                                        </div>

                                    </div>
                                </div>

                                <div class="form-group mt-3">
                                    <!--<button type="button" class="btn btn-xs  btn-primary m-1" v-on:click="saveBase" v-if="actionEnable('savebaseinformation') && !isReadOnly">Salva dati base  <font-awesome-icon :icon="['far','save']"></font-awesome-icon></button>-->
                                    <button type="button" class="btn btn-xs  btn-danger m-1" v-on:click="toggleReadOnly(true)" v-if="actionEnable('savebaseinformation') && !isReadOnly">Annulla  <font-awesome-icon :icon="['far','times-circle']"></font-awesome-icon></button>

                                    <button type="submit" class="btn  btn-xs  btn-primary" v-if="actionEnable('saveinformation')">Salva  <font-awesome-icon :icon="['far','save']"></font-awesome-icon></button>
                                </div>
                            </form>
                        </div>
                        <div class="col-4">
                            <h1 class="mb-3 text-right">
                                <button class="btn btn-link" v-on:click="asideToggle">
                                    <font-awesome-icon icon="search"></font-awesome-icon> Visualizza cronologia eventi
                                </button>
                            </h1>

                            <div class="panel-group" id="accordion">
                                <div class="panel panel-default" v-for="(t,index) in attachmenttypes" v-if="inheritance.attachments.filter(att=>att.attachmentTypeId == t.attachmentTypeId && att.inheritanceId!='00000000-0000-0000-0000-000000000000').length>0">
                                    <div class="panel-heading border-bottom border-secondary pt-2 pb-2">
                                        <h4 class="panel-title">
                                            <a data-toggle="collapse" data-parent="#accordion" :href="'#ft-'+index" class="text-dark">
                                                {{t.name}} <span class="badge badge-info rounded-circle text-white">{{inheritance.attachments.filter(att=>att.attachmentTypeId == t.attachmentTypeId  && att.inheritanceId!='00000000-0000-0000-0000-000000000000').length}}</span>

                                            </a> <button class="btn btn-sm btn-outline-info ml-3" v-on:click="addAttachemnt(t,$event)" v-if="actionEnable('addAttachment')">Aggiungi</button>
                                        </h4>

                                    </div>
                                    <div :id="'ft-'+index" class="panel-collapse collapse">
                                        <div class="panel-body mt-3 mb-3">
                                            <div class="row flex-nowrap" v-for="file in inheritance.attachments.filter(att=>att.attachmentTypeId == t.attachmentTypeId  && att.inheritanceId!='00000000-0000-0000-0000-000000000000')">
                                                <div class="col-auto  pr-0">
                                                    <button type="button" class="btn btn-link p-0" v-on:click="downloadAttachment(file.attachmentId,null,file.originalFileName)" title="Download"><font-awesome-icon icon="file-download" size="lg" class="text-info" /></button>
                                                </div>
                                                <div class="col-auto pr-0">
                                                    <font-awesome-icon :icon="getAttachmentIcon(file.originalFileName)" size="lg" class="text-primary" />
                                                </div>
                                                <div class="col-auto">
                                                    {{file.originalFileName}} <i>({{getAttachmentSize(file.weight)}})</i>
                                                    <small class="d-block text-muted">
                                                        <em>{{file.insertDate | formatFullDate}} - {{file.user.firstName}} {{file.user.lastName}}</em>
                                                    </small>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="panel panel-default">
                                    <div class="panel-heading border-bottom border-secondary pt-2 pb-2">
                                        <h4 class="panel-title">
                                            <a data-toggle="collapse" data-parent="#accordion" href="#ft-note" class="text-dark">
                                                Note
                                            </a> <span class="badge badge-info rounded-circle text-white">{{inheritance.notes.length}}</span> <button class="btn btn-sm btn-outline-info ml-3" v-on:click="addNote()">Aggiungi</button>
                                        </h4>

                                    </div>
                                    <div id="ft-note" class="panel-collapse collapse">
                                        <div class="panel-body mt-3 mb-3">
                                            <div class="row flex-nowrap border-bottom border-gray-200 mb-2" v-for="note in inheritance.notes">
                                                <div class="col-12">
                                                    <p>{{note.content}}</p>
                                                    <small class="d-block text-muted">
                                                        <em>{{note.date | formatFullDate}} - {{note.user.firstName}} {{note.user.lastName}}</em>
                                                    </small>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div v-if="payedDocument">
            <transition name="modalPayedDocument">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Segna come pagato il documento {{payedDocument.code}}</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="payedDocument=null">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col">
                                            <div class="form-group">
                                                <p>
                                                    Data ultima fattura emessa : {{payedDocument.minPayedDate  | formatDate}}

                                                </p>
                                                <label class="col-form-label" for="payedDate">Data Pagamento</label>
                                                
                                                <input type="date" @change="changePayedDate" class="form-control fullname" id="name" name="payedDate" placeholder="Data di pagamento" v-model="payedDocument.date">
                                            </div>
                                        </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 p-5">

                                            </div>
                                            <div class="col-12 text-right">

                                                <button class="btn btn-primary mr-2" v-on:click="setSwalPayed(true)">Emetti fattura</button>
                                                <button class="btn btn-warning mr-2" v-on:click="setSwalPayed(false)">Gestisci esternamente</button>
                                                <button class="btn btn-danger mr-2" v-on:click="payedDocument=null">Annulla <font-awesome-icon :icon="['far','times-circle']"></font-awesome-icon></button>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="editDocument">
            <transition name="modalDocument">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Modifica documento {{editDocument.code}}</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="editDocument=null">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-12 p-5">
                                            <table class="table w-100 table-sm p-1">
                                                <thead>
                                                    <tr class="row">
                                                        <th scope="col" class="col-6">Descrizione</th>
                                                        <th scope="col" class="col-3">IVA</th>
                                                        <th scope="col" class="col text-right">Imponibile <i></i></th>
                                                        <th scope="col" class="col-1 text-right"></th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr class="row" v-for="(row, index) in editDocument.rows">
                                                        <td scope="row" class="col-6">
                                                            <div class="form-group">
                                                                <span class="form-control-static" v-if="!row.editable">{{row.description}}</span>
                                                                <input type="text" class="form-control " placeholder="Descrizione" v-model="row.description" v-if="row.editable">
                                                            </div>
                                                        </td>
                                                        <td scope="row" class="col-3">
                                                            <select class="form-control" v-model="row.vatId" v-if="row.editable">
                                                                <option v-for="v in vats" :value="v.vatId">{{v.description}}</option>
                                                            </select>
                                                            <span class="form-control-static" v-if="!row.editable">{{row.vat.description}}</span>


                                                        </td>
                                                        <td scope="row" class="col text-right">
                                                            <span class="form-control-static" v-if="((!row.editable))">{{row.amount | toCurrency}}</span>
                                                            <input type="number" step="0.01" min="0.01" class="form-control text-right" placeholder="Imponibile" v-model.number="row.amount" v-if="row.editable">
                                                        </td>
                                                        <td scope="row" class="col-1 text-right">
                                                            <a class="btn btn-sm" v-on:click="removeEditRow(editDocument.documentId,row.documentRowId)" v-if="row.editable && editDocument.rows.length>1"><font-awesome-icon icon="times" size="2x" class="text-danger" /></a>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="5" class="text-center">
                                                            <a v-on:click="newEditRow(editDocument.documentId)"><font-awesome-icon icon="plus" class="text-info" /> Aggiungi nuova riga</a>


                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="col-12 text-right">
                                            <button class="btn btn-danger mr-2" v-on:click="editDocument=null">Annulla modifiche <font-awesome-icon :icon="['far','times-circle']"></font-awesome-icon></button>
                                            <button class="btn btn-primary" v-on:click="saveEditDocument">Salva modifiche documento <font-awesome-icon :icon="['far','save']"></font-awesome-icon></button>

                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="showModal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Aggiungi file {{attachmentType.name}}</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="hideModal()">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneAddOptions()" :useCustomSlot=true>
                                        <div class="dropzone-custom-content">
                                            <h3 class="dropzone-custom-title">Trascina il file qui</h3>
                                            <div class="subtitle">...o fai click per caricarlo dal tuo pc</div>
                                        </div>
                                    </vue-dropzone>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="showNoteModal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content bg-orange">
                                <div class="modal-header">
                                    <h5 class="modal-title">Aggiungi nuova Nota</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="hideNoteModal()">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-12">
                                            <textarea id="note-content" class="form-control" rows="10"></textarea>
                                        </div>
                                        <div class="col-12">
                                            <button type="button" class="btn btn-xs btn-primary m-1" v-on:click="saveNote()">Salva</button>

                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!-- /.col -->
    </div>


</template>
<style>
    a {
        cursor:pointer;
    }
    .row [class*='col'] {
        transition: all 0.5s ease-in-out;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .swal2-shown {
        z-index:999999;
    }
</style>
<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import axios from 'axios'

    import VueEasyPieChart from 'vue-easy-pie-chart'
    import 'vue-easy-pie-chart/dist/vue-easy-pie-chart.css'


    export default {
        computed: {
            inheritance: function () {
                return this.$store.state.inheritance;
            },
            inheritanceFlow: function () {
                return this.$store.state.inheritanceFlow;
            }
            ,
            operators: function () {
                return this.$store.state.operators;
            },
            isAdministrative: function () {

                var u = false;

                for (var i = 0; i < this.$store.state.user.roles.length; i++) {
                    if (this.$store.state.user.roles[i] == "administrative" || this.$store.state.user.roles[i] == "administrator") {
                        u = true;
                        break;
                    }
                }

                return u;
            },
            isAdministrator: function () {

                var u = false;

                for (var i = 0; i < this.$store.state.user.roles.length; i++) {
                    if (this.$store.state.user.roles[i] == "administrator") {
                        u = true;
                        break;
                    }
                }

                return u;
            },
            vats: function () {
                return this.$store.state.vats;
            },
            inheritanceTaxes: function () {
                var total = 0;
                for (var i = 0; i < this.inheritance.people.length; i++) {
                    var person = this.inheritance.people[i];
                    var documents = $.grep(person.documents, function (item) {
                        return item.type == 'proforma-balance';
                    });
                    for (var j = 0; j < documents.length; j++) {
                        for (var z = 0; z < documents[j].rows.length; z++) {
                            var row = documents[j].rows[z];
                            if (!row.editable)
                                total += row.amount;
                        }
                    }
                }
                return total;
            }
        },
        components: {
            vueDropzone: vue2Dropzone,
            VueEasyPieChart
        },
        data() {
            return {
                attachmenttypes: [],
                isReadOnly: true,
                nextStateEnable: false,
                showModal: false,
                showNoteModal: false,
                attachmentType: null,
                attachmenttypes: [],
                options: [],
                selectedPerson: null,
                editDocument: null,
                payedDocument: null
            }

        },
        name: 'InheritanceInformation',
        beforeMount() {
            var me = this;
            document.body.classList.add('sidebar-minimized');
            document.body.classList.add('brand-minimized');
            
            me.$store.dispatch('inheritanceinformation', me.$route.params.id).then((r) => {
                if (me.$store.state.inheritance) {
                    for (var i = 0; i < me.$store.state.inheritance.people.length; i++) {
                        console.log("i", i, me.$store.state.inheritance.people[i])
                        console.log(me.$store.state.inheritance.people[i])
                        if (me.$store.state.inheritance.people[i].capInfo == null) {

                            me.$store.state.inheritance.people[i].capInfo = { cap: "", provincia: "", comune: "" };

                        }
                    }
                }
                me.$store.dispatch("inheritanceCheckNextState", me.$route.params.id).then((result) => {
                    me.nextStateEnable = result.data.code == 200;
                    if (me.$store.state.inheritance) {
                        for (var i = 0; i < me.$store.state.inheritance.people.length; i++) {
                            console.log(me.$store.state.inheritance.people[i])
                            console.log("i", i, me.$store.state.inheritance.people[i])
                            if (me.$store.state.inheritance.people[i].capInfo == null) {

                                me.$store.state.inheritance.people[i].capInfo = { cap: "", provincia: "", comune: "" };

                            }
                        }
                    }
                })
            });

            me.$store.dispatch("getVats");
            me.$store.dispatch('inheritanceAttachmentTypes').then(response => {
                me.attachmenttypes = response.data;
            }).catch(error => {
                console.log(error);
            });



        },
        methods: {
            documentEdit(id) {
                var me = this;
                axios.get(
                    `inheritances/documento/${id}`
                ).then(res => {
                    me.editDocument = res.data;
                });

            },

            saveEditDocument() {
                var me = this;
                me.$swal(
                    {
                        html: `Attenzione, procedendo con le modifiche il documento emesso verr&agrave;<br><strong class="text-danger">annullato e ricreato</strong>.<br/>Procedere?`,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        var data = JSON.parse(JSON.stringify(me.editDocument));
                        me.editDocument = null;
                        axios.post(`inheritances/documento/${data.documentId}`, data).then(function (result) {

                            me.$store.dispatch('inheritanceinformation', me.$route.params.id);
                            me.$forceUpdate();

                        });

                    }
                });

                return false;

            },
            onSelect(value) {

                //this.inheritance.people[this.selectedPerson].zipCode = value.cap;
                //this.inheritance.people[this.selectedPerson].city = value.comune;
                //this.inheritance.people[this.selectedPerson].district = value.provincia;




            },
            onFocus(index) {
                if (index)
                    this.selectedPerson = (index - 1);
                console.log("focus", index);
            },
            onSearch(search, loading) {

                console.log(search);
                //  ... do some asynchronous stuff!
                loading(true);
                this.search(loading, search, this);
                //return [{"cap":"43100", "comune":"parma"}];
            },
            search: _.debounce((loading, search, vm) => {
                axios.get(
                    `cap?q=${escape(search)}`
                ).then(res => {
                    vm.options = res.data;
                    loading(false);
                });
            }, 350)
            ,
            hideModal() {
                this.showModal = false;
            },
            hideNoteModal() {
                this.showNoteModal = false;
            },
            addAttachemnt(t, event) {
                this.attachmentType = t;
                this.showModal = true;
            },
            addNote() {
                $('#note-content').removeClass('form-control--danger');
                $('#note-content').val("");
                this.showNoteModal = true;
            },
            addPerson() {
                var me = this;

                me.$store.dispatch("addperson", me.inheritance.inheritanceId).then((response) => {
                    if (response.status == 200) {
                        if (response.data.code != 200) {

                            me.$swal('Attenzione', `<div class="text-danger font-weight-bold text-left">${errors.join("<br/>")}</div>`, "error");
                        }
                        else {
                            if (!me.inheritance.people) me.inheritance.people = [];
                            response.data.data.position = me.inheritance.people.length + 1;
                            response.data.data.isNew = true;
                            me.inheritance.people.push(response.data.data);
                            me.$forceUpdate();

                        }

                    }
                });

            }
            ,
            removePerson(id) {

                this.inheritance.people = $.grep(this.inheritance.people, function (item) {
                    return item.personId != id;
                });
                for (var i = 0; i < this.inheritance.people.length; i++) {
                    this.inheritance.people[i].position = i + 1;
                }
                this.$forceUpdate();
            },

            addDocument(id) {
                var me = this;
                me.$swal(
                    {
                        html: `Aggiungendo un documento, i dati anagrafici non saranno più modificabili.<br/>Procedere?`,
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        axios.post(`inheritances/addbalance/${id}`).then(function (result) {

                            me.$store.dispatch('inheritanceinformation', me.$route.params.id);
                            me.$forceUpdate();

                        });

                    }
                });

                return false;
            },

            changeoperator() {
                var me = this;
                this.$swal(
                    {
                        title: 'Cambia operatore di riferimento',
                        input: 'select',
                        inputOptions: this.operators,
                        inputPlaceholder: 'Selezione operatore',
                        showCancelButton: true,
                        inputValidator: (value) => {

                            return new Promise((resolve) => {
                                var operator = me.operators[value];
                                if (operator) {
                                    me.$swal(
                                        {
                                            html: `Sicuri di voler associare la pratica a <strong>"<em>${operator}</em>"</strong>?`,
                                            type: "question",
                                            showCancelButton: true,
                                            confirmButtonClass: "btn-warning",
                                            confirmButtonText: "Procedi"
                                        }

                                    ).then(function (isconfirm) {
                                        if (isconfirm.value) {
                                            me.$store.dispatch("inChargeTo",
                                                {
                                                    inheritanceId: me.inheritance.inheritanceId,
                                                    userId: value
                                                }).then((result) => {
                                                    me.$swal(
                                                        {
                                                            title: "Pratica processata correttamente",
                                                            text: "",
                                                            type: "success",
                                                            showCancelButton: false,
                                                            toast: true,
                                                            timer: 2000,
                                                            showConfirmButton: false,
                                                            position: "bottom-end"
                                                        });
                                                    me.$forceUpdate();
                                                });

                                        }
                                        else {
                                            me.changeoperator();
                                        }

                                    });
                                }
                                else {
                                    resolve("Selezionare un operatore");
                                }
                            })


                        }

                    }
                );

            },
            toggleReadOnly(reload) {
                this.isReadOnly = !this.isReadOnly;
                if (reload && this.isReadOnly) {
                    this.$store.dispatch('inheritanceinformation', this.$route.params.id);
                    this.$forceUpdate();
                }
            },
            asideToggle(e) {
                e.preventDefault()
                document.body.classList.toggle('aside-menu-hidden')
            },
            getAttachmentIcon: function (filename) {
                const regex = /[^\.]\w+$/gm;
                var result = regex.exec(filename);
                var ext = "." + result[0].toLowerCase();
                switch (ext) {
                    case ".txt":
                        return ["far", "file-alt"];
                    case ".doc":
                    case ".docx":
                        return ["far", "file-word"];
                    case ".xls":
                    case ".xlsx":
                    case ".csv":
                        return ["far", "file-excel"];
                    case ".jpg":
                    case ".jpeg":
                    case ".png":
                    case ".bmp":
                    case ".tiff":
                        return ["far", "file-image"];
                    case ".pdf":
                        return ["far", "file-pdf"];
                    case ".wav":
                    case ".mp3":
                        return ["far", "file-audio"];
                    case ".ppt":
                    case ".pptx":
                        return ["far", "file-powerpoint"];
                    case ".zip":
                    case ".rar":
                    case ".7z":
                        return ["far", "file-archive"];
                    default:
                        return ["far", "file"];

                }

            },
            removeRow: function (id, rowid) {
                var me = this;

                for (var j = 0; j < me.inheritance.people.length; j++) {
                    for (var i = 0; i < me.inheritance.people[j].documents.length; i++) {
                        var d = me.inheritance.people[j].documents[i];
                        if (d.documentId == id) {
                            d.rows = $.grep(d.rows, function (item) { return item.documentRowId != rowid });
                            break;
                        }
                    }
                } 

            },
            removeEditRow: function (id, rowid) {
                var me = this;
                if (this.editDocument) {
                    this.editDocument.rows = $.grep(this.editDocument.rows, function (item) { return item.documentRowId != rowid });
                }



            },
            getInvoice: function (type, documents) {
                var me = this;
                var d = $.grep(documents, function (item) {
                    return item.type == "invoice-" + type;
                });

                if (d.length > 0) return d[0];
                return null;
            },
            newRow: function (id) {
                var me = this;
                axios.get(`inheritances/document/${this.inheritance.inheritanceId}/${id}`).then(function (result) {
                    var newRow = result.data.data;

                    for (var j = 0; j < me.inheritance.people.length; j++) {
                        for (var i = 0; i < me.inheritance.people[j].documents.length; i++) {
                            var d = me.inheritance.people[j].documents[i];
                            if (d.documentId == newRow.documentId) {
                                newRow.position = d.rows.length + 1;
                                d.rows.push(newRow);
                                break;
                            }
                        }
                    }

                });

            },
            newEditRow: function (id) {
                var me = this;
                axios.get(`inheritances/document/${this.inheritance.inheritanceId}/${id}`).then(function (result) {
                    var newRow = result.data.data;


                    var d = me.editDocument;

                    newRow.position = d.rows.length + 1;
                    d.rows.push(newRow);


                });

            },
            getAttachmentSize: function (bytes) {
                var thresh = 1024;
                if (Math.abs(bytes) < thresh) {
                    return bytes + ' B';
                }
                var units = ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
                var u = -1;
                do {
                    bytes /= thresh;
                    ++u;
                } while (Math.abs(bytes) >= thresh && u < units.length - 1);
                return bytes.toFixed(1) + ' ' + units[u];
            },
            downloadDocument: function (id) {
                var me = this;
                var url = this.$filters.documentUrl(id);
                me.$refs.attachmentA.href = url

                me.$refs.attachmentA.click();
                //axios.get(url, { responseType: 'blob' }).then(function (result) {
                //     var blob = new Blob([result.data], { type: result.headers["content-type"] });
                //    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                //        window.navigator.msSaveOrOpenBlob(blob, o);
                //    } else {
                //        me.$refs.attachmentA.href = URL.createObjectURL(blob)
                //        me.$refs.attachmentA.download = o;
                //        me.$refs.attachmentA.click()
                //    }
                //});

            },
            setInvalidSucFile() {
                var me = this;

                this.$swal(
                    {
                        title: ``,
                        html: `Sicuri di voler segnalare all'amministratore i dati non corretti?`,
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        axios.post('inheritances/setInvalidData/' + me.$route.params.id).then((response) => {


                            me.$store.dispatch('inheritanceinformation', me.$route.params.id)
                            me.$forceUpdate();
                        });
                    }
                });

            },

            confirmInvalidData() {
                var me = this;


                this.$swal(
                    {
                        title: ``,
                        html: `Sicuri di voler tornare a modificare i dati? Tutti i documenti saranno contrassegnati come annullati.`,
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        axios.post('inheritances/confirmInvalidData/' + me.$route.params.id).then((response) => {

                            me.$forceUpdate();
                            me.$store.dispatch('inheritanceinformation', me.$route.params.id)

                        });
                    }
                });




            },
            downloadAttachment: function (id, f, o) {
                var me = this;
                var url = '';
                if (f) {
                    url = this.$filters.attachemntTempUrl(f, o);
                } else {
                    url = this.$filters.attachemntUrl(id);
                }
                axios.get(url, { responseType: 'blob' }).then(function (result) {
                    var blob = new Blob([result.data], { type: result.headers["content-type"] });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                        window.navigator.msSaveOrOpenBlob(blob, o);
                    } else {
                        me.$refs.attachmentA.href = URL.createObjectURL(blob)
                        me.$refs.attachmentA.download = o;
                        me.$refs.attachmentA.click()
                    }
                });

            },
            dropzoneAddOptions: function () {
                var me = this;
                function addurl() {
                    return window.SETTINGS.apiUrl + '/inheritances/attachment/' + me.attachmentType.attachmentTypeId + '/' + me.$route.params.id;
                }
                return {
                    url: addurl(),
                    headers: { "Authorization": "Bearer " + this.$store.state.user.token },
                    success: function (a, b) {
                        this.removeFile(a);
                        me.$forceUpdate();
                        me.$store.dispatch('inheritanceinformation', me.$route.params.id).then((r) => {
                            me.attachmentType = null;
                            me.showModal = false;
                            me.$store.dispatch("inheritanceCheckNextState", me.$route.params.id
                            ).then((result) => {
                                me.nextStateEnable = result.data.code == 200;
                            })
                        });
                    }
                }
            },
            dropzoneOptions: function (typeid) {
                var me = this;
                function url() {
                    return window.SETTINGS.apiUrl + '/inheritances/uploadattachment/' + me.$refs.attachmenTypeId[0].value + '/' + me.$route.params.id;
                }
                return {
                    url: url,
                    timeout: 180000,
                    headers: { "Authorization": "Bearer " + this.$store.state.user.token },
                    success: function (a, b) {
                        this.removeFile(a);
                        if (b.code == 200) {
                            me.inheritance.attachments.push(b.data);
                        }
                        else {

                            console.log(b.code);
                            switch (b.code) {
                                case 503:
                                    me.$swal(
                                        {
                                            title: ``,
                                            html: `<div class="alert-danger">${b.message}</div><div>Se invece pensi che il file sia corretto, ma i dati della pratica siano errati, clicca su "Segnala all'amministratore".<br/>Altrimenti annulla</div>`,
                                            type: "warning",
                                            showCancelButton: true,
                                            confirmButtonClass: "btn-warning",
                                            confirmButtonText: "Segnala all'amministratore",
                                            cancelButtonText: "Annulla"
                                        }

                                    ).then(function (isconfirm) {
                                        if (isconfirm.value) {

                                            me.setInvalidSucFile();

                                        }
                                    });
                                    break;
                                default:
                                    me.$swal('Attenzione', `<div class="text-danger font-weight-bold text-left">${b.message}</div>`, "error");
                                    break;

                            }

                        }

                    }
                }
            },
            actionEnable: function (actionname) {
                //if (actionname == "addPeople") return true;
                var me = this;
                for (var i = 0; i < this.inheritanceFlow.roles.length; i++) {
                    if (this.inheritanceFlow.roles[i].actions.filter(a => a.type.toLowerCase() == actionname.toLowerCase()).length > 0)
                        return true;
                }
                return false;
            },

            nextStateDescription: function () {
                for (var i = 0; i < this.inheritanceFlow.roles.length; i++) {
                    return this.inheritanceFlow.roles[i].nextState;
                }
                return "";
            },

            changePayedDate: function () {
                var me = this;
                axios.get("inheritances/ultimafattura/" + me.payedDocument.date.substring(0, 4)).then((response) => {
            
                
                    me.payedDocument.minPayedDate = response.data.date.substring(0, 10);
                    me.payedDocument.number = response.data.number + 1;

                });

            },

            setPayed: function (id, code) {
                var me = this;
              
                axios.get(
                    `inheritances/documento/${id}`
                ).then(res => {

                    axios.get("inheritances/ultimafattura/" + res.data.year).then((response) => {
                        res.data.number = response.data.number + 1;
                        res.data.minPayedDate = response.data.date.substring(0, 10);
                        res.data.date = response.data.date.substring(0, 10);

                        me.payedDocument = res.data;

                    });



                });

            
             
            },
            setSwalPayed: function (invoice) {
                var me = this;
                var html = `Sicuri di voler attribuire il pagamento al documento<br/><strong>${me.payedDocument.code}</strong> <strong class="text-danger">SENZA EMISSIONE FATTURA</strong> ?`;
                if (invoice)
                    html = `Sicuri di voler attribuire il pagamento al documento<br/><strong>${me.payedDocument.code}</strong> <strong class="text-danger">CON EMISSIONE FATTURA</strong>  ?`
              
                this.$swal(
                    {
                        title: ``,
                        html:html ,
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        axios.post('inheritances/setpayed/' + me.payedDocument.documentId + '/' + me.payedDocument.date + "?invoice=" + invoice).then((response) => {
                            me.payedDocument = null;
                            me.$forceUpdate();
                            me.$store.dispatch('inheritanceinformation', me.$route.params.id)

                        }).catch(
                            function (error) {
                                me.$swal(
                                    {
                                        title: ``,
                                        html: 'Verifica la data pagamento',
                                        type: "error",
                                        showCancelButton: false,
                                        confirmButtonClass: "btn-warning",
                                        confirmButtonText: "OK"
                                    });
                            }
                        )
                    }
                });
            },
            inChargeToMe: function () {
                var me = this;
                this.$swal(
                    {
                        title: "Sicuri di voler prendere in carico la pratica?",
                        text: "",
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        me.$store.dispatch("inChargeTo",
                            {
                                inheritanceId: me.inheritance.inheritanceId,
                                userId: me.$store.state.user.userId
                            }).then((result) => {
                                me.$swal(
                                    {
                                        title: "Pratica presa in carico correttamente",
                                        text: "",
                                        type: "success",
                                        showCancelButton: false,
                                        toast: true,
                                        timer: 2000,
                                        showConfirmButton: false,
                                        position: "bottom-end"
                                    });
                                me.$forceUpdate();
                            });

                    }
                });



            },
            jumpOver: function () {
                var me = this;

                this.$swal(
                    {
                        title: ``,
                        html: `Sicuri di voler saltare la fase di acconto?`,
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        me.$store.dispatch("inheritanceJumpOver", me.inheritance.inheritanceId).then((response) => {
                            if (response.status == 200) {
                                if (response.data.code != 200) {
                                    var errors = [];
                                    for (var i in response.data.data) {
                                        $('.' + i).addClass("form-control--danger");
                                        errors.push(response.data.data[i]);
                                    }
                                    me.$swal('Attenzione', `<div class="text-danger font-weight-bold text-left">${errors.join("<br/>")}</div>`, "error");
                                }
                                else {

                                    me.$forceUpdate();
                                    me.$store.dispatch('inheritanceinformation', me.$route.params.id).then((r) => {

                                        me.$store.dispatch("inheritanceCheckNextState", me.$route.params.id
                                        ).then((result) => {
                                            me.nextStateEnable = result.data.code == 200;
                                        })
                                    });

                                }
                            }
                        });
                    }
                });
            },
            stepOver: function () {
                var me = this;

                this.$swal(
                    {
                        title: ``,
                        html: `Sicuri di voler forzare il passaggio della pratica in stato <strong><em>\"${me.$filters.state(me.nextStateDescription())}\"</em></strong>?`,
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        me.$store.dispatch("inheritanceNextState", me.inheritance.inheritanceId).then((response) => {
                            if (response.status == 200) {
                                if (response.data.code != 200) {
                                    var errors = [];
                                    for (var i in response.data.data) {
                                        $('.' + i).addClass("form-control--danger");
                                        errors.push(response.data.data[i]);
                                    }
                                    me.$swal('Attenzione', `<div class="text-danger font-weight-bold text-left">${errors.join("<br/>")}</div>`, "error");
                                }
                                else {

                                    me.$forceUpdate();
                                    me.$store.dispatch('inheritanceinformation', me.$route.params.id).then((r) => {

                                        me.$store.dispatch("inheritanceCheckNextState", me.$route.params.id
                                        ).then((result) => {
                                            me.nextStateEnable = result.data.code == 200;
                                        })
                                    });

                                }
                            }
                        });
                    }
                });
            },
            nextState: function () {
                var me = this;

                this.$swal(
                    {
                        title: ``,
                        html: `Sicuri di voler passare la pratica in stato <strong><em>\"${me.$filters.state(me.nextStateDescription())}\"</em></strong>?`,
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        me.$store.dispatch("inheritanceNextState", me.inheritance.inheritanceId).then((response) => {
                            if (response.status == 200) {
                                if (response.data.code != 200) {
                                    var errors = [];
                                    for (var i in response.data.data) {
                                        $('.' + i).addClass("form-control--danger");
                                        errors.push(response.data.data[i]);
                                    }
                                    me.$swal('Attenzione', `<div class="text-danger font-weight-bold text-left">${errors.join("<br/>")}</div>`, "error");
                                }
                                else {

                                    me.$forceUpdate();
                                    me.$store.dispatch('inheritanceinformation', me.$route.params.id).then((r) => {

                                        me.$store.dispatch("inheritanceCheckNextState", me.$route.params.id
                                        ).then((result) => {
                                            me.nextStateEnable = result.data.code == 200;
                                        })
                                    });

                                }
                            }
                        });
                    }
                });
            },
            ko: function () {
                var me = this;
                this.$swal(
                    {
                        title: "Sicuri di voler sospendere la pratica?",
                        text: "",
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        me.$store.dispatch("inheritcanceKo",
                            me.inheritance.inheritanceId,
                        ).then((result) => {
                            me.$store.dispatch("inheritanceCheckNextState", me.$route.params.id
                            ).then((result) => {
                                me.nextStateEnable = result.data.code == 200;
                            })
                            me.$swal(
                                {
                                    title: "Pratica sospesa correttamente",
                                    text: "",
                                    type: "success",
                                    showCancelButton: false,
                                    toast: true,
                                    timer: 2000,
                                    showConfirmButton: false,
                                    position: "bottom-end"
                                });
                            me.$forceUpdate();
                        });

                    }
                });



            },
            previous: function () {
                var me = this;
                this.$swal(
                    {
                        title: "Sicuri di voler retrocedere la pratica allo stato precedente?",
                        text: "",
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        me.$store.dispatch("inheritcancePrevious",
                            me.inheritance.inheritanceId,
                        ).then((result) => {
                            me.$store.dispatch("inheritanceCheckNextState", me.$route.params.id
                            ).then((result) => {
                                me.nextStateEnable = result.data.code == 200;
                            })
                            me.$swal(
                                {
                                    title: "Pratica retrocessa correttamente",
                                    text: "",
                                    type: "success",
                                    showCancelButton: false,
                                    toast: true,
                                    timer: 2000,
                                    showConfirmButton: false,
                                    position: "bottom-end"
                                });
                            me.$forceUpdate();
                        });

                    }
                });



            },
            removeAttachment: function (id) {
                var me = this;
                me.$swal(
                    {
                        title: "Sicuri di voler eliminare l'allegato?",
                        text: "",
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        me.inheritance.attachments = me.inheritance.attachments.filter(item => item.attachmentId !== id);
                        me.$swal(
                            {
                                title: "Allegato cancellato correttamente",
                                text: "",
                                type: "success",
                                showCancelButton: false,
                                toast: true,
                                timer: 2000,
                                showConfirmButton: false,
                                position: "bottom-end"
                            });
                    }
                });


            },

            save() {

                var me = this;
                $('.form-control--danger').removeClass('form-control--danger');
                this.inheritance.customDocumentation = this.inheritance.customAttachments.join(",");
                this.$store
                    .dispatch('inheritanceSave', this.inheritance).then(response => {
                        if (response.status == 200) {
                            if (response.data.code != 200) {
                                var errors = [];
                                for (var i in response.data.data) {
                                    $('.' + i).addClass("form-control--danger");
                                    errors.push(response.data.data[i]);
                                }
                                me.$swal('Attenzione', `<div class="text-danger font-weight-bold text-left">${errors.join("<br/>")}</div>`, "error");
                            }
                            else {
                                me.$swal(
                                    {
                                        title: "Salvataggio avvenuto correttamente",
                                        text: "",
                                        type: "success",
                                        showCancelButton: false,
                                        toast: true,
                                        timer: 2000,
                                        showConfirmButton: false,
                                        position: "bottom-end"
                                    });
                                me.toggleReadOnly(true)
                                me.$forceUpdate();
                                me.$store.dispatch('inheritanceinformation', me.$route.params.id).then((r) => {

                                    me.$store.dispatch("inheritanceCheckNextState", me.$route.params.id
                                    ).then((result) => {
                                        me.nextStateEnable = result.data.code == 200;
                                        if (!me.nextStateEnable) {
                                            var errors = [];
                                            for (var i in result.data.data) {
                                                $('.' + i).addClass("form-control--danger");
                                                errors.push(result.data.data[i]);
                                            }

                                            me.$swal(
                                                {
                                                    title: "Salvataggio avvenuto correttamente",
                                                    html: `<div class="text-left  mb-2"><strong>Ricordati che per proseguire devi inserire:</strong></div><div class="text-danger font-weight-bold text-left mb-5">${errors.join("<br/>")}</div>`,
                                                    type: "success",
                                                    showCancelButton: false,
                                                    toast: false,
                                                    timer: 4000,
                                                    showConfirmButton: false,
                                                    position: "bottom-end"
                                                });
                                        }
                                    });
                                });

                            }
                        }

                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            resetInheritance() {
                var me = this;
                me.$swal(
                    {
                        title: "Sicuri di voler rielaborare i proforma?",
                        text: "Tutti i documenti verranno annullati",
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        me.$store.dispatch('inheritancereset', me.$route.params.id).then((r) => {
                            me.$swal(
                                {
                                    title: "Operazione riuscita",
                                    text: "",
                                    type: "success",
                                    showCancelButton: false,
                                    toast: true,
                                    timer: 2000,
                                    showConfirmButton: false,
                                    position: "bottom-end"
                                });
                        });
                    }
                });
            }
            ,
            saveBase() {
                var me = this;
                $('.form-control--danger').removeClass('form-control--danger');
                this.$store
                    .dispatch('inheritanceSaveBase', this.inheritance).then(response => {
                        if (response.status == 200) {
                            if (response.data.code != 200) {
                                var errors = [];
                                for (var i in response.data.data) {
                                    $('.' + i).addClass("form-control--danger");
                                    errors.push(response.data.data[i]);
                                }
                                me.$swal('Attenzione', `<div class="text-danger font-weight-bold text-left">${errors.join("<br/>")}</div>`, "error");
                            }
                            else {
                                me.$swal(
                                    {
                                        title: "Salvataggio avvenuto correttamente",
                                        text: "",
                                        type: "success",
                                        showCancelButton: false,
                                        toast: true,
                                        timer: 2000,
                                        showConfirmButton: false,
                                        position: "bottom-end"
                                    });
                                me.isReadOnly = true;

                                me.$store.dispatch('inheritanceinformation', me.$route.params.id);
                                me.$forceUpdate();
                            }
                        }

                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
            , saveNote() {
                var me = this;
                $('#note-content').removeClass('form-control--danger');
                if ($('#note-content').val() == '') {
                    $('#note-content').addClass('form-control--danger');
                    return;
                }

                this.$store
                    .dispatch('inheritanceNoteCreate', {
                        content: $('#note-content').val(),
                        inheritanceId: me.inheritance.inheritanceId
                    }).then(response => {
                        $('#note-content').val("");
                        me.showNoteModal = false;
                        if (response.status == 200) {
                            if (response.data.code != 200) {

                                me.$swal('Attenzione', `<div class="text-danger font-weight-bold text-left">${errors.join("<br/>")}</div>`, "error");
                            }
                            else {
                                me.$swal(
                                    {
                                        title: "Salvataggio Nota avvenuto correttamente",
                                        text: "",
                                        type: "success",
                                        showCancelButton: false,
                                        toast: true,
                                        timer: 2000,
                                        showConfirmButton: false,
                                        position: "bottom-end"
                                    });
                                me.$forceUpdate();
                                me.$store.dispatch('inheritanceinformation', me.$route.params.id).then((r) => {

                                    me.$store.dispatch("inheritanceCheckNextState", me.$route.params.id
                                    ).then((result) => {
                                        me.nextStateEnable = result.data.code == 200;
                                    })
                                });
                            }
                        }

                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    };
</script>
